export default {
  title: 'Cart',
  buttons: {
    login_to_checkout: 'Login to checkout',
    checkout: 'Checkout',
  },
  go_to_menu: 'Go to menu',
};
